// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"dfc74e2e","513":"fe301fcf","703":"0b847fb2","787":"6c2d1669"}[chunkId] + ".chunk.js";
};